import { CanDeactivateFn } from "@angular/router";
import { Observable } from "rxjs";

/**
 * Components guarded against losing unsaved data implement this.
 * Returning false (or an Observable<false>) cancels the navigation.
 */
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | boolean;
}

/**
 * Fires on any navigation away from the component, including the browser
 * back button. Delegates the decision to the component's canDeactivate().
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component
) => (component?.canDeactivate ? component.canDeactivate() : true);
